import { NavLink } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

const NAV: { to: string; label: string; ic: string; end?: boolean }[] = [
  { to: "/", label: "Скринер", ic: "≡", end: true },
  { to: "/portfolio", label: "Портфель", ic: "♦" },
  { to: "/dashboard", label: "Дашборд", ic: "◐" },
  { to: "/calendar", label: "Календарь", ic: "▤" },
  { to: "/stats", label: "Статистика", ic: "▧" },
  { to: "/alerts", label: "Алерты", ic: "◔" },
];

export function Sidebar() {
  const { user, logout } = useAuth();
  return (
    <aside className="sidebar">
      <div className="logo" title="Bonds Helper">
        <span className="logo-mark">
          <span className="logo-b">B</span>
          <span className="logo-h">h</span>
        </span>
        <span className="logo-text">
          bonds
          <br />
          helper.
        </span>
      </div>
      <nav>
        {NAV.map((n) => (
          <NavLink key={n.to} to={n.to} end={n.end}>
            <span className="ic">{n.ic}</span>
            {n.label}
          </NavLink>
        ))}
      </nav>
      {user && (
        <div className="user-block">
          <div className="user-email" title={user.email}>
            {user.email}
          </div>
          <button
            type="button"
            className="user-logout"
            onClick={() => {
              void logout();
            }}
          >
            выйти
          </button>
        </div>
      )}
    </aside>
  );
}
